import EaBranding from '@propertypal/shared/src/resources/icons/products/ea-branding-icon.svg';
import EaConsultancy1 from '@propertypal/shared/src/resources/icons/products/ea-consultancy-icon1.svg';
import EaDisplayAds from '@propertypal/shared/src/resources/icons/products/ea-display-ads-icon.svg';
import WhyLeading from '@propertypal/shared/src/resources/icons/products/why-leading-portal-icon.svg';
import EaWhyTraffic from '@propertypal/shared/src/resources/icons/products/why-traffic-icon.svg';
import WhyWebsite from '@propertypal/shared/src/resources/icons/products/why-website-icon.svg';
import React from 'react';
import { ProcutsHeaderIcon } from '../headers/products/ProductsPageHeader';
import { IconItem, IconsGrid } from '../headers/products/ProductsPageHeader.style';
import { MidHeading, SmallHeading } from '../typography';
import { SponsorContainer, SponsorWrapper } from './SponsorSearchFeatures.style';

interface SASIcons extends ProcutsHeaderIcon {
  SVG: string;
}

const icons = (dev?: boolean): SASIcons[] => [
  {
    SVG: WhyWebsite,
    heading: `Your advert will take over the full top section of the new homes and resales search results page`,
    headingMaxW: 250,
  },
  {
    SVG: EaDisplayAds,
    heading: `Advert will display in a permanent spot for the duration of your campaign`,
    headingMaxW: 260,
  },
  {
    SVG: EaWhyTraffic,
    heading: `Maximise views and enquiries to your ${dev ? 'development' : 'listings'} while building brand awareness`,
    headingMaxW: 230,
  },
  {
    SVG: WhyLeading,
    heading: `Fully functional on mobile and desktop devices`,
    headingMaxW: 200,
  },
  {
    SVG: EaConsultancy1,
    heading: `You choose the location(s)`,
    headingMaxW: 120,
  },
  {
    SVG: EaBranding,
    heading: `We design the adverts for you`,
    headingMaxW: 170,
  },
];

interface SponsorSearchFeaturesProps {
  dev?: boolean;
}

const SponsorSearchFeatures: React.FC<SponsorSearchFeaturesProps> = ({ dev }) => {
  return (
    <SponsorContainer>
      <SponsorWrapper>
        <SmallHeading fontSize={22} mb={60} fontWeight="normal">
          What you get as part of the Sponsor a Search package
        </SmallHeading>
        <IconsGrid columnGap={100} rowGap={60}>
          {icons(dev).map(({ SVG, heading, text: iconText, maxW, headingMaxW }) => (
            <IconItem
              key={(typeof iconText === 'string' ? iconText : heading) || heading}
              maxW={maxW}
              headingSize={16}
              headingMaxW={headingMaxW}
              headingMt={15}
              headingWeight="normal"
            >
              <SVG />
              <div>
                <MidHeading mt={15}>{heading}</MidHeading>
              </div>
            </IconItem>
          ))}
        </IconsGrid>
      </SponsorWrapper>
    </SponsorContainer>
  );
};

export default SponsorSearchFeatures;
